import React, { useEffect, useState } from 'react'
import { createMuiTheme, Fab, FormGroup, MuiThemeProvider, Snackbar, Switch, TableCell, TextField, Tooltip, Typography, withStyles } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import Loader from 'react-loader-spinner'
import MuiAlert from '@material-ui/lab/Alert';
import editIcon from '../../assets/1@3x.png';
import api from '../api';
import { format } from 'date-fns';
import ReactExport from 'react-data-export';
import ic_downloadFile from '../../assets/ic_downloadFile.png';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import CloseImage from '../../assets/ic_close.png';
import { useHistory } from 'react-router';
import DetailMonitoringTransaksi from './DetailMonitoringTransaksi';
import Constant from '../../library/Constant';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ct = require("../../library/CustomTable");

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

const style = {
    position: "sticky",
    zIndex: 110
};

const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions()

export default function MonitoringTransaksi(props) {
    const [visibleCreate, setVisibleCreate] = React.useState(false);
    const [visibleDetail, setVisibleDetail] = React.useState(false);
    const [visibleStatus, setVisibleStatus] = React.useState(false);
    const [visibleFilter, setVisibleFilter] = React.useState(false);
    const [dataTable, setDataTable] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [create, setCreate] = React.useState(false);
    const [detailData, setDetailData] = React.useState(null);
    const [read, setRead] = React.useState(false);
    const [update, setUpdate] = React.useState(false);
    const [deleted, setDeleted] = React.useState(false);
    const [visiblePopUp, setVisiblePopUp] = React.useState(false);
    const [tglMulai, setTglMulai] = React.useState(null);
    const [tglMulaiDownload, setTglMulaiDownload] = React.useState(null);
    const [tglSelesai, setTglSelesai] = React.useState(null);
    const [tglSelesaiDownload, setTglSelesaiDownload] = React.useState(null);
    const [download, setDownload] = React.useState(false);
    const [loading, setLoading] = React.useState(false)
    const [multiDataSet, setMultiData] = React.useState([])
    const [dataFilter, setDataFilter] = React.useState([])
    const [filter, setFilter] = React.useState(false)

    const [lantai, setLantai] = React.useState('')
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [dataCount, setDataCount] = useState(10)
    const [paramQuery, setParamQuery] = React.useState(null)

    const handleSeeDetail = ({ rowData }) => {
        console.log(rowData);
        setDetailData(rowData)
        setVisibleDetail(true)
        // history.push({
        //     pathname: '/detail-report',
        //     name: 'Detail Report',
        //     state: {
        //         data: rowData,
        //     }
        // });
    }

    const onDownload = async () => {
        setLoading(true)
        const start = format(new Date(tglMulaiDownload), 'yyyy-MM-dd')
        const end = format(new Date(tglSelesaiDownload), 'yyyy-MM-dd')
        let data = []
        if (lantai !== "") {
            data = lantai.split(',')
        }
        let floorFilter = data.length > 0 ? `"floor": [${data}]` : ''
        const filter = {
            appointment_date: {
                start,
                end
            }
        }
        const body = JSON.stringify(filter)
        const urlData = data.length > 0 ? `&filter={"floor": [${data}]}` : ''
        const urlBody = `date_filter=${body}&is_download=1${urlData}`
        const res = await api.create('REPORT').getMonitoringTransaksiAndDate(urlBody)
        console.log(res.data.type, 'hehe')
        if (res.status !== 200 || res.data.type == "application/json") {
            const blob = new Blob([res.data], { type: 'application/json' });
            const reader = new FileReader();

            reader.onload = function (event) {
                const text = event.target.result;
                const json = JSON.parse(text);
                alert(json.data)
            };
            reader.readAsText(blob);
            setLoading(false)
        } else {
            var fileURL = window.URL.createObjectURL(
                new Blob([res.data])
            );
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", `Report ${format(new Date(tglMulaiDownload), 'dd-MM-yyyy')} - ${format(new Date(tglSelesaiDownload), 'dd-MM-yyyy')}.xlsx`);
            document.body.appendChild(fileLink);

            fileLink.click();
            setLoading(false)
        }

    }


    useEffect(() => {
        getListMonitoringTransaksi(page, limit)
    }, [])

    const getListMonitoringTransaksi = (a, b) => {
        let data = []
        if (lantai !== "") {
            data = lantai.split(',')
        }
        let urlData = data.length > 0 ? `&filter={"floor": [${data}]}` : ''
        api.create().getMonitoringTransaksi(`page=${a}&per_page=${b}${urlData}`).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true && response.data.data != null) {
                    if (response.data.data.length > 0) {
                        let data = response.data.data.map((item, index) => {
                            return [
                                item.transaction_code_client,
                                item.transaction_date,
                                item.appointment_date,
                                item.medical_record_no,
                                item.patient_name,
                                item.payment_method_name,
                                item.payment_digital_name,
                                item.payment_status,
                                item.bill_status,
                                item.payment_date === null ? '' : format(new Date(item.payment_date), 'dd MMM yyyy'),
                                "",
                                "",
                                item.id
                            ]
                        })
                        setDataTable(data)
                        setDataCount(response.data.total_data)
                        forceUpdate()
                    }
                } else {
                    setDataTable([])
                    setDataCount(0)
                }
            }
        })
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const updateDateRange = (a, b) => {
        console.log(a, b);
        const c = dataTable.filter((item) => {
            console.log(Number(format(new Date(item[2]), 'yyyyMMdd')));
            return Number(format(new Date(item[2]), 'yyyyMMdd')) >= Number(a) && Number(format(new Date(item[2]), 'yyyyMMdd')) <= Number(b)
        });
        setFilter(true)
        setDataFilter(c)
        forceUpdate()

    }

    const columnTable = ["Kode Transaksi",
        {
            label: "Tanggal Transaksi",
            options: {
                filter: false,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{}}>
                            {val !== null ? format(new Date(val), 'dd MMM yyyy') : ""}
                        </div>
                    )
                }
            }
        },
        {
            label: "Tanggal Reservasi",
            options: {
                filter: false,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{}}>
                            {val !== null ? format(new Date(val), 'dd MMM yyyy') : ""}
                        </div>
                    )
                }
            }
        }, "No Rekam Medis", "Nama Pasien", "Metode Pembayaran", "Digital Payment Provider", "Status Pembayaran", "Status Pembayaran HIS", "Tanggal Pembayaran",
        {
            label: "Tanggal Mulai",
            options: {
                filter: true,
                display: false,
                filterType: 'custom',
                onTableChange: console.log,
                resetFilter: () => {
                    console.log('masuk');
                },
                onFilterChange: (columnChanged, filterList) => {
                    console.log(`onFilterChange columnChanged: ${columnChanged}`);
                    console.log(filterList);
                },
                filterOptions: {
                    names: [],
                    logic(age, filters) {
                        if (filters[0] && filters[1]) {
                            return age < filters[0] || age > filters[1];
                        } else if (filters[0]) {
                            return age < filters[0];
                        } else if (filters[1]) {
                            return age > filters[1];
                        }
                        return false;
                    },
                    display: (filterList, onChange, index, column) => (
                        <div>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                    margin="normal"
                                    label="Tgl. Reservasi Awal"
                                    format="dd/MM/yyyy"
                                    clearable
                                    value={tglMulai}
                                    maxDate={new Date()}
                                    onChange={(date) => {
                                        console.log(date);
                                        setTglMulai(date)
                                        if (tglSelesai === null) {
                                            setTglSelesai(date)
                                        }
                                        date === null ? updateDateRange(format(new Date(), 'yyyyMMdd'), tglSelesai === null ? format(new Date(date), 'yyyyMMdd') : format(new Date(tglSelesai), 'yyyyMMdd')) : updateDateRange(format(new Date(date), 'yyyyMMdd'), tglSelesai === null ? format(new Date(date), 'yyyyMMdd') : format(new Date(tglSelesai), 'yyyyMMdd'))
                                        // forceUpdate()
                                    }}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                    ),
                },
                customHeadRender: ({ index, ...columnMeta }, sortColumn) => (
                    <TableCell key={columnMeta.index} onClick={() => sortColumn(index)} style={{}}>
                        <Typography style={{ color: '#5e9fff', fontSize: 14, fontWeight: 'bold', textAlign: 'left' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', textAlign: 'start', width: 77, }}>
                            {/* <Typography> */}
                            {val}
                            {/* </Typography> */}
                        </div>
                    )
                }
            }
        },
        {
            label: "Tanggal Selesai",
            options: {
                display: false,
                filterType: 'custom',
                filterOptions: {
                    names: [],
                    logic(age, filters) {
                        if (filters[0] && filters[1]) {
                            return age < filters[0] || age > filters[1];
                        } else if (filters[0]) {
                            return age < filters[0];
                        } else if (filters[1]) {
                            return age > filters[1];
                        }
                        return false;
                    },
                    display: (filterList, onChange, index, column) => (
                        <div>
                            <FormGroup column>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <DatePicker
                                        margin="normal"
                                        clearable
                                        label="Tgl. Reservasi Akhir"
                                        format="dd/MM/yyyy"
                                        minDate={tglMulai === null ? new Date() : tglMulai}
                                        maxDate={new Date()}
                                        value={tglSelesai}
                                        onChange={(date) => {
                                            setTglSelesai(date)
                                            if (tglMulai === null && date !== null) {
                                                setTglMulai(new Date())
                                            }
                                            if (date === null) {
                                                getListMonitoringTransaksi(page, limit)
                                            } else {
                                                updateDateRange(tglMulai === null ? format(new Date(), 'yyyyMMdd') : format(new Date(tglMulai), 'yyyyMMdd'), format(new Date(date), 'yyyyMMdd'))
                                            }
                                            // forceUpdate()
                                        }}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        style={{ width: '100%' }}
                                    />
                                </MuiPickersUtilsProvider>
                            </FormGroup>
                        </div>
                    ),
                }
            }
        },
        {
            name: "Aksi",
            options: {
                filter: false,
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 110, backgroundColor: 'white' }}>
                        <Typography style={{ textAlign: 'center' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                // setCellProps: () => ({ style }),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <LightTooltip title={"Detail"} arrow>
                                <button
                                    style={{
                                        backgroundColor: "transparent",
                                        fontSize: 20,
                                        outline: 'none',
                                        borderColor: 'transparent'
                                    }
                                    }
                                    onClick={() => handleSeeDetail(tableMeta)}
                                >
                                    <img src={editIcon} style={{ width: 30, height: 30 }} />
                                    {/* <img src={editIcon} style={{ width: 20, height: 20 }} /> */}
                                </button>
                            </LightTooltip>
                            {/* <LightTooltip title={"Print"} arrow>
                                <button
                                    style={{
                                        backgroundColor: "transparent",
                                        fontSize: 20,
                                        outline: 'none',
                                        borderColor: 'transparent',
                                        marginRight: 20
                                    }
                                    }
                                    onClick={() => null}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <img src={ic_circle} style={{ width: 32, height: 32 }} />
                                        <img src={ic_print} style={{ width: 18, height: 18, marginLeft: -25 }} />
                                    </div> 
                                </button>
                            </LightTooltip> */}
                        </div>
                    )
                }
            }
        }
    ];

    const options = {
        filterType: 'multiselect',
        fixedHeader: true,
        filter: false,
        search: true,
        sort: true,
        print: false,
        download: false,
        selectableRows: false,
        viewColumns: false,
        count: dataCount,
        rowsPerPage: limit,
        responsive: 'scrollMaxHeight',
        serverSide: true,
        onFilterChange: (columnChanged) => {
            // setDataFilter(e)
            if (columnChanged === null) {
                setTglMulai(null)
                setTglSelesai(null)
                setFilter(false)
                getListMonitoringTransaksi(page, limit)
            }
        },
        onTableChange: (action, tableState) => {
            // console.log(action, tableState);
            switch (action) {
                case 'changePage':
                    setPage(tableState.page + 1)
                    setLimit(tableState.rowsPerPage)
                    getListMonitoringTransaksi(tableState.page + 1, tableState.rowsPerPage)
                    break;
                case 'changeRowsPerPage':
                    setPage(tableState.page + 1)
                    setLimit(tableState.rowsPerPage)
                    getListMonitoringTransaksi(tableState.page + 1, tableState.rowsPerPage)
                    break;
                case 'sort':
                    // setLoading(true)
                    sorting(tableState)
                    break;
                default:
                    break;
            }
        }
    };

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 3000, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#5e9fff"
                height={100}
                width={100}
            />
        </div>
    );

    const sorting = (tableState) => {
        let arr = dataTable
        arr.sort(function (a, b) {
            if (String(tableState.announceText).includes('descending')) {
                return a[tableState.activeColumn].localeCompare(b[tableState.activeColumn]);
            } else {
                return b[tableState.activeColumn].localeCompare(a[tableState.activeColumn]);
            }
        });
        console.log(dataTable);
        setDataTable(arr)
        forceUpdate()
    };

    return (
        <div style={{ paddingTop: 10, position: 'relative' }}>
            {loading && (loadingComponent)}
            <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div style={{ position: 'absolute', top: 30, left: 10, zIndex: 10, }}>
                <div style={{ display: 'flex' }}>
                    <TextField
                        placeholder={'Lantai'}
                        style={{ width: 150 }}
                        onChange={(e) => {
                            setLantai(e.target.value)
                        }}
                    />
                    <div onClick={(e) => getListMonitoringTransaksi(page, limit)} style={{ backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', textAlign: 'center', padding: '0px 20px', marginLeft: 20 }} >
                        <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Filter</Typography>
                    </div>
                </div>
            </div>
            <LightTooltip title={"Download Data"} arrow>
                <div style={{ backgroundColor: 'white', boxShadow: '0 0 16px 0 rgba(130, 130, 130, 0.25)', position: 'absolute', right: 115, top: 30, zIndex: 10, cursor: 'pointer' }}
                    onClick={() => {
                        setVisiblePopUp(true)
                    }}
                >
                    <img src={ic_downloadFile} style={{ width: 24, height: 24 }} />
                </div>
            </LightTooltip>
            {download && (
                <ExcelFile hideElement={true} filename={`Report ${format(new Date(tglMulaiDownload), 'dd-MM-yyyy')} - ${format(new Date(tglSelesaiDownload), 'dd-MM-yyyy')}`}>
                    <ExcelSheet dataSet={multiDataSet} name="Sheet" />
                </ExcelFile>
            )}
            <div >
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        data={dataTable}
                        columns={columnTable}
                        options={options}
                    />
                </MuiThemeProvider>
            </div>
            {visibleDetail && (
                <DetailMonitoringTransaksi
                    onClose={() => setVisibleDetail(false)}
                    data={detailData}
                />
            )}

            {visiblePopUp && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 800 }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18, whiteSpace: 'nowrap' }}>Download Report</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ width: '100%', alignSelf: 'center', padding: 0, justifySelf: 'right' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => setVisiblePopUp(false)}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '20px 50px' }}>
                            <div className="column-1">
                                <div className="">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="tanggal mulai"
                                            label="Tanggal Mulai"
                                            required={true}
                                            format="dd/MM/yyyy"
                                            maxDate={new Date()}
                                            value={tglMulaiDownload}
                                            onChange={(date) => {
                                                setTglMulaiDownload(date)
                                                forceUpdate()
                                            }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            style={{ width: '100%', margin: 0 }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </div>
                            <div className="column-2">
                                <div className="">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="tanggal selesai"
                                            label="Tanggal Selesai"
                                            required={true}
                                            value={tglSelesaiDownload}
                                            format="dd/MM/yyyy"
                                            maxDate={new Date()}
                                            minDate={new Date(tglMulaiDownload)}
                                            onChange={(date) => {
                                                setTglSelesaiDownload(date)
                                                forceUpdate()
                                            }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            style={{ width: '100%', margin: 0 }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </div>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div onClick={() => setVisiblePopUp(false)} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div onClick={(e) => onDownload()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Download</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
